import { Close, Folder } from '@mui/icons-material';
import { Autocomplete, Box, Button, Divider, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Mapa from '../../componentes/mapa/Mapa';

const ActividadesEconomicas = ({ datos, setDatos }) => {

    const [catalogoActividades, setCatalogoActividades] = useState([]);
    const getCatalogo = async () => {

        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/catalogo_actividades`)
            .then((res) => res.json())
            .then((respuesta) => {
                setCatalogoActividades(respuesta.data);
            })
    }

    useEffect(() => {
        getCatalogo();
    }, []);

    const [galeriaActividades, setGaleriaActividades] = useState(datos.galeria_actividades && datos.galeria_actividades.length > 0 ? datos.galeria_actividades : []);
    const [galeriaProductosServicios, setGaleriaProductosServicios] = useState(datos.galeria_productos_servicios && datos.galeria_productos_servicios.length > 0 ? datos.galeria_productos_servicios : [[]]);
    useEffect(() => {
        setDatos({ target: { name: "galeria_actividades", value: galeriaActividades } });
    }, [galeriaActividades]);

    useEffect(() => {
        //console.log(galeriaProductosServicios);
        setDatos({ target: { name: "galeria_productos_servicios", value: galeriaProductosServicios } });
    }, [galeriaProductosServicios]);

    const removeImg = (imgurl, galeria, index = null) => {
        switch (galeria) {
            case 'galeria_actividades':
                setGaleriaActividades(prevGaleria => prevGaleria.filter(img => img.dataurl !== imgurl));
                break;
            case 'galeria_productos_servicios':
                setGaleriaProductosServicios(prevGaleria => {
                    let newGal = [...prevGaleria];
                    newGal[index] = newGal[index].filter(img => img.dataurl !== imgurl);
                    return newGal;
                });
                break;
            case 'galeria_unidades_produccion':
                setGaleriaUnidadesProduccion(prevGaleria => {
                    let newGal = [...prevGaleria];
                    newGal[index] = newGal[index].filter(img => img.dataurl !== imgurl);
                    return newGal;
                });
                break;
        };
    }

    const handleInput = (e, galeria = false, index = null) => {
        let imagen = e.target.files[0] ?? null;
        if (imagen) {
            const reader = new FileReader();

            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result
                switch (galeria) {
                    case 'galeria_actividades':
                        setGaleriaActividades(prevGaleria => [...prevGaleria, imagen]);
                        break;
                    case 'galeria_productos_servicios':
                        setGaleriaProductosServicios(prevGaleria => {
                            let newGal = [...prevGaleria];
                            newGal[index] = [...newGal[index], imagen];
                            return newGal;
                        });
                        break;
                    case 'galeria_unidades_produccion':
                        setGaleriaUnidadesProduccion(prevGaleria => {
                            let newGal = [...prevGaleria];
                            newGal[index] = [...newGal[index], imagen];
                            return newGal;
                        });
                        break;
                };
            }

            reader.readAsDataURL(imagen);
        }
    }

    // para el autocomplete de giro
    const [giros, setGiros] = useState(datos.giro_actividad);

    useEffect(() => {
        let e = {
            target: {
                name: 'giro_actividad',
                value: giros
            }
        }
        setDatos(e)
    }, [giros]);

    const handleGiros = (giro) => {
        setGiros((prev) => {
            let dup = prev.filter((p) => p.codigo_act === giro.codigo_act);
            if (dup.length === 0) {
                prev.push(giro);
            }
            let e = {
                target: {
                    name: 'giro_actividad',
                    value: prev
                }
            }
            setDatos(e);
            return prev;
        })
    }

    const removeGiro = (codigo) => {
        setGiros(giros.filter(g => g.codigo_act !== codigo));
    }
    const [giroSeleccionado, setGiroSeleccionado] = useState('');

    const [productosServicios, setProductosServicios] = useState(
        datos.productos_servicios && datos.productos_servicios.length > 0 ?
            datos.productos_servicios :
            [
                {
                    nombre: '',
                    descripcion: '',
                    volumen_anual: ''
                }
            ]);

    const addProductoServicio = () => {
        setProductosServicios((prev) => {
            prev.push({
                nombre: '',
                descripcion: '',
                volumen_anual: ''
            });
            return prev;
        });
        setGaleriaProductosServicios(prevGaleria => [...prevGaleria, []]);
    }

    const handleProducto = (value, label, index) => {
        setProductosServicios((prevProductos) => {
            // Crear una nueva copia del array productosServicios
            const nuevosProductos = [...prevProductos];
            // Crear una copia del producto actualizado
            const productoActualizado = { ...nuevosProductos[index] };
            // Actualizar la propiedad del producto
            productoActualizado[label] = value;
            // Actualizar el array de productos con el producto actualizado
            nuevosProductos[index] = productoActualizado;
            setDatos({ target: { value: nuevosProductos, name: 'productos_servicios' } });
            return nuevosProductos;
        });
    }

    const [unidadesProduccion, setUnidadesProduccion] = useState(
        datos.unidades_produccion.length > 0 ?
            datos.unidades_produccion :
            [
                {
                    nombre: '',
                    descripcion: '',
                    ubicacion: '',
                    proceso: '',
                }
            ]
    );

    const [galeriaUnidadesProduccion, setGaleriaUnidadesProduccion] = useState(datos.galeria_unidades_produccion ?? [[]]);
    useEffect(() => {
        //console.log(galeriaUnidadesProduccion);
        setDatos({ target: { name: "galeria_unidades_produccion", value: galeriaUnidadesProduccion } });
    }, [galeriaUnidadesProduccion]);

    const addUnidadProduccion = () => {
        setUnidadesProduccion((prev) => {
            prev.push({
                nombre: '',
                descripcion: '',
                ubicacion: '',
                proceso: '',
            });
            return prev;
        });
        setGaleriaUnidadesProduccion(prevGaleria => [...prevGaleria, []]);
    }

    const handleUnidadProduccion = (value, label, index) => {
        setUnidadesProduccion((prevProductos) => {
            const nuevosProductos = [...prevProductos];
            const productoActualizado = { ...nuevosProductos[index] };
            productoActualizado[label] = value;
            nuevosProductos[index] = productoActualizado;
            setDatos({ target: { value: nuevosProductos, name: 'unidades_produccion' } });

            return nuevosProductos;
        });
    }
    return (
        <Grid container spacing={2} sx={{ mb: { xs: 10, lg: 0 } }}>
            {/* Lado izq  */}
            <Grid item lg={6} xs={12}>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">Actividades económicas*</Typography>
                </Box>
                {/* Giros */}
                <Box sx={{ mb: 2, width: { lg: '80%', xs: '100%' } }}>
                    <Autocomplete
                        fullWidth
                        disableClearable
                        name="giro_actividad"
                        options={catalogoActividades}
                        getOptionLabel={(option) => option.nombre_act ?? ''}
                        value={giroSeleccionado}
                        onChange={(e, actividad) => {
                            handleGiros(actividad);
                            setGiroSeleccionado(actividad.codigo_act);
                        }}
                        renderInput={params => (
                            <TextField {...params} label="Giro de actividad económica" />
                        )}
                    />
                    {giros && giros.length > 0 && giros.map((giro) => {
                        //console.log(giro);
                        return (
                            <MenuItem key={giro.codigo_act} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography noWrap>
                                    {giro.nombre_act}
                                </Typography>
                                <IconButton onClick={() => removeGiro(giro.codigo_act)}>
                                    <Close />
                                </IconButton>
                            </MenuItem>
                        )
                    })}
                </Box>
            </Grid>
            {/* Lado derecho */}
            <Grid item lg={6} xs={12}>
                {/* Galeria de actividades max 7 */}
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">Fotogalería de actividades productivas de la empresa</Typography>
                    <Typography variant="subtitle1">(Máximo 7 fotografías)</Typography>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                    {galeriaActividades && galeriaActividades.map((image) => (
                        <Box key={image.name} sx={{ position: 'relative', mr: 2, mb: 2, border: 1, borderColor: '#e0dcda', p: 1, display: 'flex', alignItems: 'center' }}>
                            <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0, m: 1 }} onClick={() => removeImg(image.dataurl, 'galeria_actividades')}>
                                <Close />
                            </IconButton>
                            <img src={image.dataurl} alt={image.name} width="150px" />
                        </Box>
                    ))}
                </Box>
                <Box sx={{ mb: 2, display: 'flex', }}>
                    <Button disabled={galeriaActividades.length > 6} component="label" variant="contained" startIcon={<Folder />}>
                        Agregar <input name="galeriaActividades" onInputCapture={(e) => handleInput(e, 'galeria_actividades')} type="file" accept='image/*' hidden />
                    </Button>
                </Box>
            </Grid>

            <Grid item lg={6} sx={12}>
                <Divider />
                <Box sx={{ my: 2 }}>
                    <Typography variant="h6">Principales productos y/o servicios*</Typography>
                </Box>

                {productosServicios.map((producto, index) => {
                    return (
                        <Box key={index}>
                            <Box sx={{ my: 2 }}>
                                <Typography fontWeight="bold" component="p">Producto / Servicio {index + 1}</Typography>
                            </Box>
                            <Box sx={{ mb: 2 }}>
                                <TextField
                                    fullWidth
                                    value={producto.nombre}
                                    onChange={(e) => handleProducto(e.target.value, 'nombre', index)}
                                    label="Producto/Servicio"
                                    placeholder=""
                                />
                            </Box>
                            <Box sx={{ mb: 2 }}>
                                <TextField
                                    fullWidth
                                    value={producto.descripcion}
                                    onChange={(e) => handleProducto(e.target.value, 'descripcion', index)}
                                    multiline
                                    label="Descripción"
                                    placeholder=""
                                />
                            </Box>
                            <Box sx={{ mb: 2 }}>
                                <TextField
                                    fullWidth
                                    value={producto.volumen_anual}
                                    onChange={(e) => handleProducto(e.target.value, 'volumen_anual', index)}
                                    label="Volumen anual"
                                    placeholder=""
                                />
                            </Box>
                            {/* Galeria de productos / servicios max 7 */}
                            <Box sx={{ mb: 2 }}>
                                <Typography fontWeight="bold">Fotogalería del producto/servicio {index + 1}</Typography>
                                <Typography variant="subtitle1">(Máximo 7 fotografías)</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                {galeriaProductosServicios[index] && galeriaProductosServicios[index].map((image, i) => (
                                    <Box key={image.dataurl} sx={{ position: 'relative', mr: 2, mb: 2, border: 1, borderColor: '#e0dcda', p: 1, display: 'flex', alignItems: 'center' }}>
                                        <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0, m: 1 }} onClick={() => removeImg(image.dataurl, 'galeria_productos_servicios', index)}>
                                            <Close />
                                        </IconButton>
                                        <img src={image.dataurl} alt={image.name} width="150px" />
                                    </Box>
                                ))}
                            </Box>
                            <Box sx={{ mb: 2, display: 'flex', }}>
                                <Button disabled={galeriaProductosServicios[index].length > 6} component="label" variant="contained" startIcon={<Folder />}>
                                    Agregar <input name={`productos_servicios${index}`} onInputCapture={(e) => handleInput(e, 'galeria_productos_servicios', index)} type="file" accept='image/*' hidden />
                                </Button>
                            </Box>
                            {index + 1 !== productosServicios.length && <Divider />}
                        </Box>
                    )
                })
                }
                <Divider />
                <Button sx={{ my: 2 }} onClick={addProductoServicio} variant="contained">Nuevo producto/servicio</Button>
            </Grid>
            {/* Unidades de produccion */}
            <Grid item lg={6} xs={12}>
                <Divider />
                <Box sx={{ my: 2 }}>
                    <Typography variant="h6">Unidades de producción*</Typography>
                    {unidadesProduccion.map((unidad, index) => {
                        return (
                            <Box key={index}>
                                <Box sx={{ my: 2 }}>
                                    <Typography fontWeight="bold" component="p">Unidad {index + 1}</Typography>
                                </Box>
                                <Box sx={{ mb: 2 }}>
                                    <TextField
                                        fullWidth
                                        value={unidad.nombre}
                                        onChange={(e) => handleUnidadProduccion(e.target.value, 'nombre', index)}
                                        label="Nombre"
                                        placeholder=""
                                    />
                                </Box>
                                <Box sx={{ mb: 2 }}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        value={unidad.descripcion}
                                        onChange={(e) => handleUnidadProduccion(e.target.value, 'descripcion', index)}
                                        label="Descripción"
                                        placeholder=""
                                    />
                                </Box>
                                <Box sx={{ mb: 2 }}>
                                    <TextField
                                        fullWidth
                                        value={unidad.proceso}
                                        onChange={(e) => handleUnidadProduccion(e.target.value, 'proceso', index)}
                                        label="Proceso"
                                        placeholder=""
                                    />
                                </Box>
                                <Box sx={{ mb: 2 }}>
                                    <Mapa
                                        start={
                                            unidadesProduccion[index].ubicacion != ''
                                                ? {
                                                    lat: Number(unidadesProduccion[index].ubicacion.split(",")[0]),
                                                    lng: Number(unidadesProduccion[index].ubicacion.split(",")[1])
                                                } : {
                                                    lat: 20.6854551,
                                                    lng: -103.3542671
                                                }
                                        }
                                        editable={true}
                                        buscador={true}
                                        handleSelect={(newVal) => {
                                            handleUnidadProduccion(`${newVal.lat},${newVal.lng}`, 'ubicacion', index);
                                        }}
                                    />
                                </Box>
                                {/* Galeria de productos / servicios max 7 */}
                                <Box sx={{ mt: 10, mb: 2 }}>
                                    <Typography fontWeight={'bold'}>Fotogalería de la unidad {index + 1}</Typography>
                                    <Typography variant="subtitle1">(Máximo 2 fotografías)</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                    {galeriaUnidadesProduccion[index].map((image, i) => (
                                        <Box key={image.dataurl} sx={{ position: 'relative', mr: 2, mb: 2, border: 1, borderColor: '#e0dcda', p: 1, display: 'flex', alignItems: 'center' }}>
                                            <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0, m: 1 }} onClick={() => removeImg(image.dataurl, 'galeria_unidades_produccion', index)}>
                                                <Close />
                                            </IconButton>
                                            <img src={image.dataurl} alt={image.name} width="150px" />
                                        </Box>
                                    ))}
                                </Box>
                                <Box sx={{ mb: 2, display: 'flex', }}>
                                    <Button disabled={galeriaUnidadesProduccion[index].length > 1} component="label" variant="contained" startIcon={<Folder />}>
                                        Agregar <input name={`unidades_produccion${index}`} onInputCapture={(e) => handleInput(e, 'galeria_unidades_produccion', index)} type="file" accept='image/*' hidden />
                                    </Button>
                                </Box>
                                {index + 1 !== unidadesProduccion.length && <Divider />}
                            </Box>
                        )
                    })
                    }
                    <Divider />
                    <Button sx={{ my: 2 }} onClick={addUnidadProduccion} variant="contained">Nueva unidad</Button>

                </Box>
            </Grid>
        </Grid>
    )
}

export default ActividadesEconomicas